import type { FaireProductEntity } from "../../entity_types/product";

export const p_sawf67gyub: FaireProductEntity = {
  token: "p_sawf67gyub",
  type: "product",
  name: "Classic Ossetra Caviar",
  brandToken: "b_dgbnq7fk3m",
  brandName: "Golden Goat Caviar",
  imageUrl:
    "https://cdn.faire.com/fastly/8c2e1eeda12522d3f9ee5caec86d867dad7b06b6064521500e7535694d3beff9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/509d315e5172652d82697b340e4526d9126d48b746d8ff03ad260417d69df70a.png",
  ],
  priceDollars: 59,
  description:
    "Ossetra is the most well-known caviar around. Ossetra (Gueldenstaedtti) is the last species originally from the Caspian Sea and now relocated to aquaculture farms where they are sustainably farmed.\n\nMedium-sized, firm, and juicy beads with a bold, clean, nutty, buttery taste. Toasty brown color to dark brown.",
  tags: [],
  msrpDollars: 118,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:20:57.299Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
